<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/customers'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
// import { CustomerSalesContractService } from "../../../_services/api/accounts/customer-sales-contract.service";
import { CustomerContractLineDescriptionService } from "../../../_services/api/settings/customers/customer-contract-line-description.service";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      validationSummary: [],
      formModel: {
        Inactive: true,
        Description: undefined,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Contract Line Description",
        pageRoute: "/customer-contract-line-description",
        saveEndPoint: "CustomerSalesContractLineDescription",
        recordEndPoint: "CustomerSalesContractLineDescription",
        updateEndPoint: "CustomerSalesContractLineDescription",
        updateKeyField: "RecordId",
        updateKeyFieldType: "Guid",
        exportFileName: "Contract Line Description List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerSalesContractLineDescription",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "customer-contract-line-description",
              mode: "review",
              idMode: "Guid",
              idProperty: "RecordId",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/customer-contract-line-description/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Description",
              dataField: "Description",
              allowHiding: false,
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
      },
      setLoading: false,
    };
  },
  computed: {
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Description",
                required: true,
                screenField: "Description",
                label: {
                  text: "Description",
                },
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (this.baseView.mode == "create") {
        this.formModel.Inactive = e.value;
      } else {
        if (e.value == true && e.previousValue == false)
          this.formModel.Inactive = e.value;
        else {
          this.setLoading = true;
          await CustomerContractLineDescriptionService.checkInactiveValidation(
            this.formModel.RecordId
          )
            .then((res) => {
              this.setLoading = false;
              if (res.data) {
                this.formModel.Inactive = e.value;
              } else {
                this.formModel.Inactive = true;
                e.component.beginUpdate();
                e.component.option("value", true);
                e.component.endUpdate();

                this.validationSummary = [];
                this.validationSummary.push({
                  message: `${this.formModel["Description"]} is associated with active customer contract line records. This may not be marked inactive until it is no longer associated with customer contract line records.`,
                });
              }
            })
            .catch((err) => {
              if (err) this.setLoading = false;
            });
        }
      }
    },
  },
};
</script>
